const PharmaceuticalScience = () => {
    return (
        <>
            <div className="about-ed-wrapper-impact">
                <h2 className="about-ed-heading-impact">Pharmaceutical Science</h2>
                <div className="about-ed-block-impact">
                    <div className="about-ed-content-impact">
                        <ul className="journal-ul-impact">
                            <li className="journal-li-impact">Pharmaceutics</li>
                            <li className="journal-li-impact">Pharmacology</li>
                            <li className="journal-li-impact">Pharmacognosy & Phytochemistry</li>
                            <li className="journal-li-impact">Pharmaceutical Chemistry</li>
                            <li className="journal-li-impact">Pharmaceutical Biotechnology</li>
                            <li className="journal-li-impact">Pharmacy practice</li>
                            <li className="journal-li-impact">Pharmacogenomics</li>
                            <li className="journal-li-impact">Medicinal Chemistry</li>
                            <li className="journal-li-impact">Molecular Pharmacology</li>
                            <li className="journal-li-impact">Novel drug delivery system</li>
                            <li className="journal-li-impact">Nanotechnology</li>
                            <li className="journal-li-impact">Analytical Chemistry</li>
                            <li className="journal-li-impact">Organic Chemistry</li>
                            <li className="journal-li-impact">Natural Chemistry</li>
                            <li className="journal-li-impact">Polymer Sciences</li>
                            <li className="journal-li-impact">Clinical Pharmacy</li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PharmaceuticalScience;